<script setup lang="ts">
import { useProvetHead } from '@/composables/useProvetHead.js'
useProvetHead()
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity var(--n-transition-slowly);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

html.disable-transitions {
  --n-transition-quickly: 0;
  --n-transition-slowly: 0;
}
</style>
